import styled from 'styled-components';
import Text from '../../atoms/Text';
export const Row = styled.div`
  display: grid;
  grid-column-gap: 5px;
  grid-row-gap: 8px;
  grid-template-columns: repeat(3, 1fr);
`;
export const TextName = styled(Text).attrs({
  fontWeight: 'bold',
  fontSize: 3,
  color: 'primary',
  mb: 2
})``;